import stringify from 'json-stringify-pretty-compact';
import * as React from 'react';
import MonacoEditor from 'react-monaco-editor';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as EditorActions from '../../../actions/editor';
import { EDITOR_FOCUS, LAYOUT, COMPILEDPANE } from '../../../constants';
import CompiledSpecDisplayHeader from '../compiled-spec-header';
import ResizeObserver from 'rc-resize-observer';
class CompiledSpecDisplay extends React.PureComponent {
    componentDidMount() {
        this.props.setCompiledEditorReference(this.editor);
    }
    render() {
        return (React.createElement("div", { className: 'full-height-wrapper' },
            React.createElement(CompiledSpecDisplayHeader, null),
            React.createElement(ResizeObserver, { onResize: ({ width, height }) => {
                    this.editor.layout({ width, height: height });
                } },
                React.createElement(MonacoEditor, { height: this.props.compiledVegaPaneSize - LAYOUT.MinPaneSize, options: {
                        folding: true,
                        minimap: { enabled: false },
                        readOnly: true,
                        scrollBeyondLastLine: false,
                        wordWrap: 'on',
                    }, language: "json", value: stringify(this.props.value), editorDidMount: (editor) => {
                        editor.onDidFocusEditorText(() => {
                            this.props.compiledEditorRef &&
                                this.props.compiledEditorRef.deltaDecorations(this.props.decorations, []);
                            this.props.editorRef && this.props.editorRef.deltaDecorations(this.props.decorations, []);
                            this.props.setEditorFocus(EDITOR_FOCUS.CompiledEditor);
                        });
                        this.editor = editor;
                    } }))));
    }
}
function mapStateToProps(state) {
    return {
        compiledEditorRef: state.compiledEditorRef,
        compiledVegaPaneSize: state.compiledVegaPaneSize,
        decorations: state.decorations,
        editorRef: state.editorRef,
        mode: state.mode,
        sidePaneItem: state.sidePaneItem,
        value: state.compiledPaneItem == COMPILEDPANE.Vega ? state.vegaSpec : state.normalizedVegaLiteSpec,
    };
}
export function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setCompiledEditorReference: EditorActions.setCompiledEditorRef,
        setEditorFocus: EditorActions.setEditorFocus,
    }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(CompiledSpecDisplay);
